var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#1ca0db;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3796",
    "data-name": "Group 3796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16228",
    "data-name": "Path 16228",
    className: "cls-1",
    d: "M106.7,56.228l.968,3.823a3.005,3.005,0,0,1-2,3.649l-7.426,2.186a3.006,3.006,0,0,1-3.771-1.964q-.02-.061-.036-.126l-8.2-30.645A3.007,3.007,0,0,1,88.2,29.516l7.351-2.226a3.007,3.007,0,0,1,3.79,1.927c.016.049.031.1.044.148l3.141,11.409Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16229",
    "data-name": "Path 16229",
    className: "cls-1",
    d: "M94.323,63.394a18.232,18.232,0,0,1-2.651.892,3.107,3.107,0,0,1-3.181-1.1c-1.108-1.4-2.994-3.758-5.181-6.43C70.76,41.426,62.943,37.8,53.22,39.224c-4.251.622-5.992,2.057-9.893,3.59-3.8,1.5-10.469,1.455-10.643-2.889-.112-2.786,5.278-5.326,11.369-9.249C53.2,24.783,58.5,26.065,66.616,28.559c9.125,2.8,15.41,4.87,19.88,5.583"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16230",
    "data-name": "Path 16230",
    className: "cls-1",
    d: "M54.5,86.614c8.969,4.175,11.483-1.386,11.483-1.386s6.206-.363,7.311-6.25c3.8.335,8.416-2.406,8.244-6.623,5.324.1,10.247-5.648,5.825-10.592"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16231",
    "data-name": "Path 16231",
    className: "cls-1",
    d: "M20.57,63.8s2.529,1.72,5,3.316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16232",
    "data-name": "Path 16232",
    className: "cls-1",
    d: "M36.738,35.254c-4.416-.755-8.171-1.348-8.171-1.348"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16233",
    "data-name": "Path 16233",
    className: "cls-1",
    d: "M43.824,86.039a1.446,1.446,0,0,0-1.133-.611,6.354,6.354,0,0,1-4.248-1.484A6.231,6.231,0,0,1,37.03,81.79a1.593,1.593,0,0,0-1.951-.915c-2.7.731-5.538-1.745-5.724-4.6a1.334,1.334,0,0,0-1.209-1.265c-3.951-.272-6.157-4.847-3.647-7.293,1.5-1.46,5.527-.91,6.732,1.93a1.072,1.072,0,0,0,1.4.579,1.017,1.017,0,0,0,.105-.051c2.4-1.3,5.137.176,6,2.722a1.241,1.241,0,0,0,1.34.814c3.968-.455,5.71,1.945,6.062,5.215a1.573,1.573,0,0,0,1.535,1.389c2.615-.066,4.3,1.236,4.573,2.709A5.012,5.012,0,0,0,54.5,86.613C55.006,88.183,46.824,90.266,43.824,86.039Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_117",
    "data-name": "Line 117",
    className: "cls-1",
    x1: 81.533,
    y1: 72.354,
    x2: 75.239,
    y2: 65.151
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_118",
    "data-name": "Line 118",
    className: "cls-1",
    x1: 73.29,
    y1: 78.977,
    x2: 68.526,
    y2: 73.476
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_119",
    "data-name": "Line 119",
    className: "cls-1",
    x1: 65.981,
    y1: 85.228,
    x2: 62.752,
    y2: 81.248
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16234",
    "data-name": "Path 16234",
    className: "cls-1",
    d: "M8.3,56.228l-.968,3.823a3.005,3.005,0,0,0,2,3.649l7.426,2.186a3.006,3.006,0,0,0,3.771-1.964q.019-.061.036-.126l8.2-30.645A3.007,3.007,0,0,0,26.8,29.516L19.448,27.29a3.007,3.007,0,0,0-3.79,1.927c-.016.049-.031.1-.044.148L12.473,40.774Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default __webpack_public_path__ + "static/media/partner.8abf8bd484d38e79e1f6187a887d7bc0.svg";
export { ForwardRef as ReactComponent };